export default __webpack_public_path__ + "static/media/perks-valueprop.44e80bfd.svg";